<script setup lang="ts">
import { computed } from 'vue'

import { useContentBlock } from '../../../content-blocks/composables/use-content-block'
import ParagraphTypeConsentRevokeButton from './ParagraphTypeConsentRevokeButton.vue'

const props = defineProps<{
  id: string
}>()

const id = computed(() => props.id)
const contentBlock = useContentBlock(id.value, 'vueComponent')

const components = {
  ParagraphTypeConsentRevokeButton
} as const

type ComponentNames = keyof typeof components

</script>

<template>
  <component :is="components[contentBlock.data.vueComponent.componentName as ComponentNames]" />
</template>
